import Header from './components/Header';
import Hero from './components/Hero';
import Cards from './components/Cards';
import Updates from './components/Updates';
import FAQ from './components/FAQ';
import Features from './components/Features';
import Contact from './components/Contact';
import Media from './components/Media';
import Index from './components/Index';
import Ranking from './components/Ranking';
import Carousel from './components/Carousel';
import App from './components/App';
import Topics from './components/Topics';
import About from './components/About';
import Comments from './components/Comments';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Cards />
        <Updates />
        <FAQ />
        <Features />
        <Contact />
        <Media />
        <Index />
        <Ranking />
        <Carousel />
        <App />
        <Topics />
        <About />
        <Comments />
      </main>
      <Footer />
    </div>
  );
}